<template>
	<div class="pond-wrapper">
		<file-pond
			ref="pond"
			:name="name"
			:label-idle="`<span class='!text-gray-600'>${label} or <span class='underline'>Browse</span></span>`"
			:accepted-file-types="accept"
			:allow-multiple="multiple"
			:store-as-file="true"
			:instant-upload="instant"
			max-parallel-uploads="4"
			drop-on-page="true"
			drop-on-element="false"
			:before-add-file="isSizeAllowed"
			:before-remove-file="handleRemoval"
			@addfile="handleFileAdd"
		/>
	</div>
</template>
<script setup>
import { ref } from 'vue'
import vueFilePond from 'vue-filepond'

import FilePondPluginFileValidateType from 'filepond-plugin-file-validate-type/dist/filepond-plugin-file-validate-type.esm.js'
import FilePondPluginImagePreview from 'filepond-plugin-image-preview/dist/filepond-plugin-image-preview.esm.js'
import FilePondPluginFileEncode from 'filepond-plugin-file-encode'

import 'filepond/dist/filepond.min.css'
import 'filepond-plugin-image-preview/dist/filepond-plugin-image-preview.min.css'

const FilePond = vueFilePond(FilePondPluginFileValidateType, FilePondPluginImagePreview, FilePondPluginFileEncode)

const props = defineProps({
	name: {
		type: String,
		default: 'profileImg',
	},
	label: {
		type: String,
		default: 'Drop Image',
	},
	accept: {
		type: String,
		default: 'image/png,image/gif,image/jpeg,image/webp',
	},
	multiple: {
		type: Boolean,
		default: false,
	},
	instant: {
		type: Boolean,
		default: true,
	},
	fileSizeLimit: {
		type: Number,
		default: 10485760,
	},
})

const emit = defineEmits(['completed'])

const pond = ref(null)

const isSizeAllowed = (file) => file.fileSize < props.fileSizeLimit
const handleRemoval = () => emit('completed', false)
const handleFileAdd = () => emit('completed', true)
const handleReset = () => pond.value.removeFiles()

defineExpose({ handleReset })
</script>
<style lang="scss" scoped>
.pond-wrapper {
	&:deep(.filepond--credits) {
		display: none;
	}
	&:deep(.filepond--panel-root) {
		border-radius: 0;
	}
	&:deep(.filepond--root) {
		margin: 0 !important;
	}
}
</style>
